import ConcurrentRequest from "../../components/ConcurrentRequest";

const ConcurrentRequestPage = () => {
  return <ConcurrentRequest />;
};

export default ConcurrentRequestPage;
